import { render, staticRenderFns } from "./KeyHandling.vue?vue&type=template&id=7b4ab318&"
import script from "./KeyHandling.vue?vue&type=script&lang=js&"
export * from "./KeyHandling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports